import * as z from "zod/v4";

export const createTiktokIntegration = {
  name: "createTiktokIntegration" as const,
  input: z.object({
    code: z.string(),
    appKey: z.string(),
    isReturnsEnabled: z.boolean(),
    isOmsEnabled: z.boolean(),
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().nullish(),
  }),
};
